function ProductCard({ nom, prix, image}){
    return(
        <div style={{ border: "1px solid #ccc", padding: "10px", width: "200px" }}>
            <img src={image} alt={nom} style={{ width: "100%" }} />
            <h3>{nom}</h3>
            <p>{prix}</p>
            <button>Acheter</button>
        </div>       
    );
}
export default ProductCard;